<template>
  <div role="group" class="b-form-group form-group">
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('FIRSTNAME')">
          <inputvalidation :formerror="formError" name="first_name">
            <b-form-input type="text" v-model="formData.first_name"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('LASTNAME')">
          <inputvalidation :formerror="formError" name="last_name">
            <b-form-input type="text" v-model="formData.last_name"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('PHONENUMBER')">
          <inputvalidation :formerror="formError" name="phone_number">
            <b-form-input type="text" v-model="formData.phone_number"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('EMAIL')">
          <inputvalidation :formerror="formError" name="email">
            <b-form-input type="email" v-model="formData.email"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('ROLE')">
          <inputvalidation :formerror="formError" name="role">
            <b-form-select v-model="formData.role" :options="roleOptions">
              <option value="">{{$t('SELECTROLE')}}</option>
            </b-form-select>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'VolunteersAssociatesForm',
    props: ['formData', 'formError'],
    data()
    {
        const me = this;
        return {
            roleOptions: [
                { value: 'VOLUNTEER', text: me.$i18n.t('VOLUNTEER') },
                { value: 'ASSOCIATE', text: me.$i18n.t('ASSOCIATE') },
            ],
        };
    },
};
</script>